import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetCompanionSessionsQuery,
  GetCompanionSessionsQueryVariables,
} from "./GetCompanionSessions.generated";

export const GET_COMPANION_SESSIONS: TypedDocumentNode<
  GetCompanionSessionsQuery,
  GetCompanionSessionsQueryVariables
> = gql`
  query getCompanionSessions($limit: Int, $offset: Int) {
    companionSessions(limit: $limit, offset: $offset) {
      companionSessionUuid
      createdAt
      updatedAt
      sessionType
      title
      companionsUsed
    }
  }
`;
